<tyl-form-field 
  [label]='label | translate' 
  [ngStyle]="{'width': selectWidth}"
  [errorMessage]='errorMessage'
  [hint]='hint | translate'
  [hintAlign]='hintAlign'
>
  <mat-select
    name="Select"
    [(ngModel)]="_selected"
    (ngModelChange)="selectedChange.emit($event)"
    [required]='required'
    [disabled]='disabled'
    tabIndex="{{tabIndex}}"
    multiple
    #selectionModel="ngModel"
      #matSelect
    (openedChange)="openChange($event);"
    [disableOptionCentering]="disableOptionCentering">
    <mat-select-trigger *ngIf="_selected && _selected.length > 1">
      Multiple Selected
    </mat-select-trigger>
    <tyl-select-check-all *ngIf="!hideSelectAll"
                          [model]="selectionModel" 
                          [values]="dataSourceIds">
    </tyl-select-check-all>
    <mat-option *ngFor="let item of sortedDataSource;" [value]="getValue(item)">
      {{getDisplay(item) | translate}}
    </mat-option>
  </mat-select>
</tyl-form-field> 
